module.exports = __webpack_public_path__ + "img/GL.1f608cf7.png";